import Vue from 'vue'
import { hasOperationPermission } from '@/utils/permission'
import _ from 'lodash'

//特別文字
function replaceSpecialChar(input) {
  input.value = input.value.replace(
    /[①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡㍻〝〟㏍㊤㊥㊦㊧㊨㈲㈹㍾㍽㍼∮∑∟⊿]+/gim,
    ''
  )
}

function removeChild(el, binding) {
  const { value } = binding
  if (value) {
    const { code, group } = value
    if (code) {
      if (!hasOperationPermission(code, group)) {
        el && el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}
/**
 * @description 自定义指令v-permissions
 */
Vue.directive('permissions', {
  inserted(el, binding) {
    removeChild(el, binding)
  },
  // bind(el, binding) {
  //   removeChild(el, binding)
  // },
  // update(el, binding) {
  //   console.info('update')
  //   removeChild(el, binding)
  // },
})

/**
 * @description 自定义指令v-drag
 */
Vue.directive('drag', {
  bind(el, binding, vNode) {
    if (
      el.querySelector('.el-dialog__header') &&
      el.querySelector('.el-dialog')
    ) {
      const dialogHeaderEl = el.querySelector('.el-dialog__header')
      const dragDom = el.querySelector('.el-dialog')
      dialogHeaderEl.style.cssText += ';cursor:move;'
      dragDom.style.cssText += ';top:0;'

      const getStyle = (function () {
        if (window.document.currentStyle) {
          return (dom, attr) => dom.currentStyle[attr]
        } else {
          return (dom, attr) => getComputedStyle(dom, null)[attr]
        }
      })()

      dialogHeaderEl.onmousedown = (e) => {
        const disX = e.clientX - dialogHeaderEl.offsetLeft
        const disY = e.clientY - dialogHeaderEl.offsetTop

        const dragDomWidth = dragDom.offsetWidth
        const dragDomHeight = dragDom.offsetHeight

        const screenWidth = document.body.clientWidth
        const screenHeight = document.body.clientHeight

        const minDragDomLeft = dragDom.offsetLeft
        const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

        const minDragDomTop = dragDom.offsetTop
        const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight

        let styL = getStyle(dragDom, 'left')
        let styT = getStyle(dragDom, 'top')

        if (styL.includes('%')) {
          styL = +document.body.clientWidth * (+styL / 100)
          styT = +document.body.clientHeight * (+styT / 100)
        } else {
          styL = +styL.slice(0, -2)
          styT = +styT.slice(0, -2)
        }

        document.onmousemove = function (e) {
          let left = e.clientX - disX
          let top = e.clientY - disY

          if (-left > minDragDomLeft) {
            left = -minDragDomLeft
          } else if (left > maxDragDomLeft) {
            left = maxDragDomLeft
          }

          if (-top > minDragDomTop) {
            top = -minDragDomTop
          } else if (top > maxDragDomTop) {
            top = maxDragDomTop
          }

          dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`

          vNode.child.$emit('drag-dialog')
        }

        document.onmouseup = function () {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    }
  },
})

Vue.directive('numberFormat', {
  update: function (el, binding) {
    setTimeout(() => {
      // 聚焦元素
      const element =
        el.querySelector('.el-input__inner') ||
        el.querySelector('.el-textarea__inner') ||
        el
      element.classList.add('number')
      if (element.value) {
        let numeral = require('numeral')
        let format = '0,0'
        if (binding.modifiers.float) {
          let n = binding.value || 1
          format = `0,0.${_.padEnd('0', Number(n), '0')}`
        }
        if (element.value) {
          element.value = numeral(element.value).format(format)
        }
      }
    }, 0)
  },
})

/**
 * @description 自定义textarea行数和字符的限制
 */
Vue.directive('specialChar', {
  bind(el, binding, vnode) {
    const input =
      el.querySelector('.el-input__inner') ||
      el.querySelector('.el-textarea__inner') ||
      el
    input.addEventListener('compositionstart', () => {
      vnode.locking = true
    })
    input.addEventListener('compositionend', () => {
      vnode.locking = false
      input.dispatchEvent(new Event('input'))
    })

    input.onkeyup = () => {
      if (vnode.locking) {
        return
      }
      replaceSpecialChar(input)
      input.dispatchEvent(new Event('input'))
    }
  },
})

Vue.directive('input', {
  bind(el, binding, vnode) {
    const input =
      el.querySelector('.el-input__inner') ||
      el.querySelector('.el-textarea__inner') ||
      el
    input.addEventListener('compositionstart', () => {
      vnode.locking = true
    })
    input.addEventListener('compositionend', () => {
      vnode.locking = false
      input.dispatchEvent(new Event('input'))
    })
    //输入监听处理
    input.onkeyup = () => {
      if (vnode.locking) {
        return
      }
      // v-input.num
      if (binding.modifiers.num) {
        //只能输入数字（开头可以多个0）
        onlyNum(input)
      }
      //v-input.num_point
      else if (binding.modifiers.num_point) {
        //只能输入数字+小数点（可以多个小数点）
        onlyNumPoint(input)
      }
      //v-input.float
      else if (binding.modifiers.float) {
        //只能输入浮点型（只能一个小数点）
        onlyFloat(input, binding.value || 1)
      }
      //  v-input.int
      else if (binding.modifiers.int) {
        //只能输入整数（0+正整数）（开头不能多个0）
        onlyInt(input)
      }
      //v-input.intp
      else if (binding.modifiers.intp) {
        //只能输入正整数
        onlyIntp(input)
      }
      //v-input.alp
      else if (binding.modifiers.alp) {
        //只能输入字母
        onlyAlp(input)
      }
      //v-input.num_alp
      else if (binding.modifiers.num_alp) {
        //只能输入数字+字母
        onlyNumAlp(input)
      }
      //v-input.arith
      else if (binding.modifiers.arith) {
        //四则运算符+数字
        onlyArith(input)
      }
      //桁数制御と全半角
      else if (binding.modifiers.halfkana) {
        onlyHalfKana(input)
      }
      input.dispatchEvent(new Event('input'))
    }

    input.onblur = () => {
      if (binding.modifiers.float) {
        let numeral = require('numeral')
        let n = binding.value || 1
        let format = `0,0.${_.padEnd('0', Number(n), '0')}`
        if (input.value) {
          input.value = numeral(input.value).format(format)
        }
      }
      if (binding.modifiers.intp) {
        let numeral = require('numeral')
        let format = `0,0`
        if (input.value) {
          input.value = numeral(input.value).format(format)
        }
      }
    }

    //数字
    function onlyNum(input) {
      input.value = input.value.replace(/\D+/g, '')
    }
    //整数(0+正整数)
    function onlyInt(input) {
      let value = input.value
      value = value.replace(/\D+/g, '')
      input.value = value ? Number(value).toString() : value //去掉开头多个0
    }
    //正整数
    function onlyIntp(input) {
      if (!/^[1-9][0-9]*$/.test(input.value)) {
        let value = input.value.replace(/\D+/g, '')
        if (value && value.substring(0, 1) === '0') {
          //0开头去除0
          value = value.substring(1)
        }

        input.value = value
      }
    }

    //数字+小数点
    function onlyNumPoint(input) {
      input.value = input.value.replace(/[^\d.]/g, '')
    }

    //浮点型
    // eslint-disable-next-line no-unused-vars
    function onlyFloat(input, n) {
      let value = input.value
      value = value.replace(/[^\d.]/g, '')
      value = value.replace(/^\./g, '')
      value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      if (n && Number(n) > 0) {
        //限制n位
        var d = new Array(Number(n)).fill(`\\d`).join('')
        // eslint-disable-next-line no-useless-escape
        var reg = new RegExp(`^(\\-)*(\\d+)\\.(${d}).*$`, 'ig')
        value = value.replace(reg, '$1$2.$3')
      }
      if (value && value.at(-1) !== '.') {
        value = parseFloat(value).toString() //去掉开头多个0
      }
      input.value = value
    }
    //字母
    function onlyAlp(input) {
      input.value = input.value.replace(/[^A-Za-z]/g, '')
    }
    //数字+字母+#+,
    function onlyNumAlp(input) {
      input.value = input.value.replace(/[^A-Za-z0-9-#,]/g, '')
    }

    //四则运算+-*/()数字
    function onlyArith(input) {
      let value = input.value
      if (value) {
        input.value = value.split('').reduce((prev, cur) => {
          // eslint-disable-next-line no-useless-escape
          if (/^[\d|\-|\+|\*|\/|\.|\(|\)]+$/.test(cur)) {
            return prev + cur
          }
          return prev
        }, '')
      }
    }
    //桁数制御と全半角制御が必要です
    function onlyHalfKana(input) {
      input.value = input.value.replace(/^[^\x01-\x7E\uFF61-\uFF9F]+$/, '')
    }
  },
})

// クリックすると強制的にピントがずれます
Vue.directive('blur-on-click', {
  inserted(el) {
    el.addEventListener('click', (event) => {
      event.target.blur()
    })
  },
})
